<template>
  <div
    :class="{
      'shadow rounded-lg': true,
      'dark:bg-gray-850 dark:text-white bg-white': !transparent,
      'overflow-hidden': !isOverflowAuto,
    }"
  >
    <div>
      <div
        v-if="title || $slots.title"
        class="flex flex-col sm:flex-row sm:justify-between sm:items-center sm:p-6 py-5 px-4 space-y-2 sm:space-y-0"
      >
        <div class="text-lg font-medium dark:text-gray-100">
          <slot name="title">
            {{ title }}
          </slot>
        </div>

        <slot name="title-right" />
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: "UiCard",

  props: {
    title: {
      type: String,
      default: "",
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    isOverflowAuto: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>
